import React from "react";
import styled from "styled-components";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import SlotsFilterInput from "../../components/SlotsInfo/SlotsFilterInput";
import SlotsList from "../../components/SlotsInfo/SlotsList";
import { isMobile } from "../../utils";

const SlotsInfo = () => {
  return (
    <SlotsInfoContainer>
      <Heading className="heading">Available Slots</Heading>
      <SlotsListContainer justify="flex-start" align="flex-start">
        <SlotsFilterInput />
        <SlotsList />
      </SlotsListContainer>
    </SlotsInfoContainer>
  );
};

const SlotsInfoContainer = styled.section`
  .heading {
    margin-bottom: 24px !important;
  }
`;

const SlotsListContainer = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
  &:first-child {
    flex: 0 1 30%;
  }
  &:nth-child(2) {
    flex: 0 1 70%;
  }
`;

export default SlotsInfo;
